import {captureException} from '@sentry/browser';
import {setServerConfig} from '../config/configProvider';

export const getConfigManually = async () => {
  // don't load config from CONFIG_JS on local dev
  if (__DEVELOPMENT__) {
    return;
  }
  try {
    const response = await fetch('/api/olympus/info');
    const result = await response.json();
    if (result) {
      setServerConfig(result, false);
    }
  } catch (e) {
    captureException(e);
  }
};
